export const replaceCommasWithDot = (value: string) => {
  return +value.replaceAll('%', '').replace(',', '.');
};
